import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=855437d4&scoped=true"
import script from "./CampaignTable.vue?vue&type=script&lang=ts"
export * from "./CampaignTable.vue?vue&type=script&lang=ts"
import style0 from "./CampaignTable.vue?vue&type=style&index=0&id=855437d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855437d4",
  null
  
)

export default component.exports